/*
  workshop（车间故障统计报告）by赵祥悦 2020/9/29
*/
<template>
    <div class="WorkShopAlarmStatistics mainWrap">
        <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);" v-loading="tableloading">
            <!-- 左边导航栏 -->
            <el-aside style="width:auto;">
                <leftNav msg="/WFS001"></leftNav>
            </el-aside>
            <!-- 右侧主体部分 -->
            <el-scrollbar class="machineWrap" style="height:100%;width:100%;" >
                <el-main>
                    <div class="mainWrao">
                        <!-- 头部车间名-工厂名 -->
                        <div class="title">
                            <div class="titlename" v-if="$store.state.isMarketAccount==='1'">
                                <p class="name" >
                                    *****{{$t('ganttV2.marketPublicTitle')}}
                                </p>
                                <p class="name">
                                    - *****{{$t('ganttV2.factory')}}
                                </p>
                            </div>
                            <div class="titlename" v-else-if="$store.state.lang===0">
                                <p class="name" >
                                    {{shopInfo.nameEn}}
                                </p>
                                <p class="name">
                                    - {{factoryInfo.nameEn}}
                                </p>
                            </div>
                            <div class="titlename" v-if='$store.state.lang===1'>
                                <p class="name" >{{shopInfo.nameZh}}</p>
                                <p class="name">- {{factoryInfo.nameZh}}</p>
                            </div>
                            <div class="rightWrap">
                                <label style="margin-right:10px;font-size:12px;">{{$t('WorkShopDashBoard.label1')}}</label>
                                <ul style="display:flex;">
                                    <li v-for="item in options" :key="item.value" class="everyWorkShop" :class="{'activeWorkShop':item.value == onevalue}" @click="changeLine(item)">
                                        {{item.label}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!--蒙板-->
                        <!-- <div class="mask" v-show="noMachine">
                            <p >{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</p>
                        </div> -->
                        <div class="tableWrap">
                            <!-- 车间故障统计报告 -->
                            <div class="ProductivityReport dlwarp">
                                <h2 class="miniTitle">{{$t('WorkShopFaultsStatistics.title')}}</h2>
                                <div class="datepart">
                                    <!-- 选择的日期范围 -->
                                    <div style="display:inline-block;margin-right:10px;" v-if="titleStartDate !== ''">
                                        <p>{{titleStartDate}} ~ {{titleEndDate}}</p>
                                    </div>
                                    <!-- 导出按钮 -->
                                    <el-button class="exportBtn" @click="download" icon="el-icon-download">{{$t('WorkShopDashBoard.exportBtn')}}</el-button>
                                    <!-- 时间选择器 -->
                                    <el-date-picker
                                        class="weekPicker"
                                        v-model="weekvalue"
                                        type="week"
                                        :format="$t('WorkShopDashBoard.format')"
                                        :picker-options="weekPickerOptions"
                                        @change="changeWeek"
                                        :clearable='false'
                                        placeholder="选择周">
                                    </el-date-picker>
                                    <!-- 上一周下一周按钮 -->
                                    <div class="changetime">
                                        <el-button size="mini"  icon="el-icon-arrow-left" @click="weekChange('last')"></el-button>
                                        <span style="margin:0 10px;">{{$t('WorkShopDashBoard.weeklabel')}}</span>
                                        <el-button size="mini" icon="el-icon-arrow-right" :disabled="btnDisCopy" @click="weekChange('next')"></el-button>
                                    </div>
                                </div>
                            </div>
                            <!-- 表格数据 -->
                            <div v-if="noMachine==true" class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</div>
                            <div v-else-if="noMachine==false && noMachineInFactory==true" class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentInFactory')}}</div>
                            <el-table  
                                class="table"
                                :header-cell-style="{background:'white'}"
                                :data="policeTableData"
                                ref="policeTable"
                                :height='heightTable'
                                border
                                :cell-style="addClass"
                                :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                                style="width: 100%; margin-top:15px;"
                                v-else-if="noMachine==false && noMachineInFactory==false"
                            >
                                <el-table-column
                                    fixed
                                    prop="tlties"
                                    :label="$t('WorkShopDashBoard.event')"
                                    width="280">
                                    <el-table-column
                                    :label="$t('WorkShopDashBoard.total')"
                                    width="280">
                                        <template slot-scope="scope">
                                        <div>
                                            <span v-if="$store.state.lang ===1" >{{scope.row.msgZh}}</span>
                                            <span v-if="$store.state.lang ===0" >{{scope.row.msgEn}}</span>
                                        </div>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column
                                    v-for="(item) in activepoliceTabletitle"
                                    :key="item.label"
                                    :prop="item.prop"
                                    :label="item.label"
                                    min-width="120"
                                    >
                                    <el-table-column
                                    :label="secondTable[item.prop]+''" min-width="120"
                                    >
                                        <template slot-scope="scope">
                                            <span>{{scope.row.alarmReportList[item.prop]}}</span>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column
                                    fixed="right"
                                    :label="$t('WorkShopDashBoard.total')"
                                    width="130">
                                    <el-table-column
                                    fixed="right"
                                    :label="secondTable[999]+''"
                                    width="130">
                                        <template slot-scope="scope">
                                        <span>{{scope.row.alarmReportList[999]}}</span>
                                        <!-- <span>{{scope.row.alarmReportList[policeTabletitle[policeTabletitle.length-1].prop]}}</span> -->
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                            </el-table>
                        </div>       
                    </div>
                    <!-- 底部文字 -->
                    <div class="ptbottomfont" v-if="$store.state.newroute ==='zhongce'">
                        <span>Powered by www.tst-cloud.com</span>
                        <a href="http://www.tst-cloud.com/" target="_blank">{{$t('ZcrubberEquiepmentIOT.title')}}</a>
                    </div>
                </el-main>
            </el-scrollbar>
        </el-container>
    </div>
</template>

<script>
import { formatDate } from '../assets/js/date.js'
import leftNav from "@/components/nav.vue"
export default {
    name:"workshop",
    components:{
        leftNav
    },
    data(){
        return {
            shopId: null,
            shopArr: [],
            factoryInfo:{},
            shopInfo: {},
            tableloading:false,
            //  车间数据
            options: [],
            // 选中的机械id
            machineID: [],
            // 时间选择器
            dateValue: '',
            selectActive: '0',
            //车间故障统计报告
            weekvalue:'',// 时间选择器（周）
            nowWeek:'',
            // 控制下一周是否可选
            btnDisCopy: true,
            // 表格的信息
            policeTabletitle:[],
            policeTableData:[],
            secondTable:[],

            // 时间选择器逻辑
            weekPickerOptions: {
                disabledDate: (time) =>{
                    var times = Date.now()
                    return time.getTime() > times;
                },
                firstDayOfWeek:1
            },
            // 选择的日期范围
            startDate:'',// startDate
            endDate:'',// endDate
            heightTable:null,
            resDate: '',
             // 一周的日期
            titleStartDate:'',
            titleEndDate:'',
            // 默认车间的显示
            onevalue:'',
            //有无设备
            noMachine:false,
            //工厂下是否有设备
            noMachineInFactory:false,
            //机器信息列，机器列表
            machineNums:[]
        }
    },
    created(){
        this.shopId=this.$store.state.defaultShopId
        console.log(this.shopId)
        // if (this.$store.state.reloadState === false) {
        //     this.$store.state.reloadState = true
        //     this.$parent.reload()
        // }else{
            this.GetMonday()
        // }
    },
    mounted(){
        // 获取本周一的时间 作为截止时间
        let date = new Date()
        var day = date.getDay() || 7;
        const d = new Date(new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1 - day))
        this.resDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
        // 数据初始化
        this.getShopList()
    },
    computed: {
        islangChange () {
            return this.$store.state.lang
        },
        activepoliceTabletitle(){
            return this.policeTabletitle.filter((item,index)=>{
                return (index<this.policeTabletitle.length-1)
            })
        }
    },
    watch: {
        
        islangChange (curval, oldval) {
            if (curval != oldval) {
                this.getShopList()
            }
        }
    },
    methods:{
        //表格单元格颜色
        addClass({row, column, rowIndex, columnIndex}) {
            let cellStyle='';
            //建德二期、建德三期改变
            if(this.$store.state.defaultFactoryId!=2 && this.$store.state.defaultFactoryId!=17)return false
            //排除第一列和最后一列
            if(columnIndex == 0 || columnIndex>this.machineNums.length)return false
            let arr=[]
            //获取一行的数据,按照机器顺序进行排序
            this.policeTabletitle.forEach(item=>{
                arr.push(row.alarmReportList[item.prop])
            })
            arr.unshift("")
            //分别判断一行的每一个颜色
            switch (true) {
                case (arr[columnIndex]>=1 && arr[columnIndex]<=5):
                    cellStyle = 'background : #2a82e4; color : #fff';
                    break;
                case (arr[columnIndex]>=6 && arr[columnIndex]<=10):
                    cellStyle = 'background : #ac33c1; color : #fff';
                    break;
                case (arr[columnIndex]>=11):
                    cellStyle = 'background : #d43030; color : #fff';
                    break;
                default:
                    cellStyle = '';
            }
            return cellStyle;
        },
        // 改变车间时触发
        changeLine(item){
            this.onevalue=item.value
            this.shopArr[1]=item.value
            this.shopId = item.value
            this.getShopInfo()
            this.FaultAlarmtTable()
        },
        // 获取车间列表
        getShopList() {
            // this.noMachine=false
            let _this = this
            this.axios({
                method: 'get',
                url: '/url/selectChooseShop',
                params:{
                    language: _this.$store.state.lang,
                    shopId:_this.shopId
                }
            }).then(function(res){
                if (res.data.success === 'true') {
                    if(res.data.options !==undefined && res.data.options.length > 0 ){
                        _this.noMachine=false
                        if (res.data.belong === 1) {
                            if(localStorage.getItem('isMarketAccount') === '1') {
                                _this.$store.commit('marketAccountShop',res.data.options)
                                }
                                _this.options = res.data.options[0].children
                                _this.onevalue = _this.$store.state.defaultShopId
                                _this.getShopInfo()
                                _this.FaultAlarmtTable()//表格数据
                        } else{
                            _this.$router.push({path: '/login', name: 'login'})
                        }
                    }else{
                        _this.noMachine=true
                        _this.$message(_this.$t('Dailyequipment.noEquipmentData'));
                        _this.$store.commit('loginOut')
                        _this.$router.replace({
                            path: '/login'
                        })
                    }
                } else {
                _this.$message.error('Machine list loading failed')
                }
            })
        },
        // 获取车间信息
        getShopInfo(){
            let _this = this
            // 获取车间信息
            this.axios({
                method: 'get',
                url: '/url/selectFactoryShop',
                params:{
                    shopId: _this.shopId
                }
            }).then(function(res){
                if (res.data.success === 'true') {
                    _this.shopArr = [res.data.factory.id, res.data.shop.id]
                    _this.factoryInfo = res.data.factory
                    _this.shopInfo = res.data.shop
                } else {
                    _this.$message.error('shopInfo loading failed')
                }
            })
        },
        //导出
        download(){
            if(this.policeTableData == null || this.policeTableData.length == 0){
                this.$message.error(this.$t('gantt.error'));
            }else{
                let signTime = new Date().getTime()
                this.$store.commit('nowsign', signTime)
                // 设备报告下载
                window.open(`/download/alarmStatisticsReportExportLog?dataType=1&shopId=${this.shopArr[1]}&date=${this.weekvalue}&language= ${this.$store.state.lang}&sign=${this.$store.state.sign}&auth_Code=${this.$store.state.authCode}&sign_time=${signTime}&route=${this.$store.state.newroute}&factory_id=${this.$store.state.factoryId}`, '_blank')
            }
        },
        // 触发 周选择器
        changeWeek(){
            // 控制下个月禁选按钮
            var timeD = this.weekvalue
            var time = `${timeD.getFullYear()}-${timeD.getMonth()+1}-${timeD.getDate()}`
            const nowTimeStamp = new Date(time).getTime()
            const endTimeStamp = new Date(this.resDate).getTime()
            if (nowTimeStamp >= endTimeStamp) {
                this.btnDisCopy = true
            }else{
                this.btnDisCopy = false
            }
            // 处理参数格式
            var myDate = this.weekvalue
           
            let x =new Date(myDate.getTime() - 86400000);
            var newDate = x.getDate()
            var tYear = x.getFullYear();
            var tMonth = x.getMonth();
            var m = tMonth + 1;
            var tDate = myDate.getDate()
            this.weekvalue = ` ${tYear}-${m}-${newDate}`
            // 获取时间区间
            let ddd = tDate//本周的周一
            let sundaySjc = myDate.setDate(ddd)-86400000//获取周一时间戳
            let saturdaySjc = myDate.setDate(ddd)+86400000*5//获取周日时间戳
            this.getTimeSection(sundaySjc,saturdaySjc)

            //请求表格数据
            this.FaultAlarmtTable()
        },
        // 上一周 下一周 按钮
        weekChange(type){
            var time = this.weekvalue
            var timeArr = time.split('-')
            var timeStr = timeArr[2].slice(0,2)
            let newTime = ''
            let monD //获取周一
            if (type === 'last'){//上周
                let y = timeArr[0]//年
                let mon = timeArr[1]//月
                let monDay //每个月有多少天

                // 处理monDay
                if(mon==2 || mon==4 || mon==6 || mon==8 || mon==9 || mon==11 || mon==1){
                    monDay = 31
                }else if(mon==5 || mon==7 || mon==10 || mon==12){
                    monDay = 30
                }else if(mon==3){
                    let Leap = ''+y/4
                    if(Leap.length>3){
                        monDay = 28
                    }else{
                        monDay = 29
                    }
                }
                // 
                if (timeArr[1]-1 === 0) {
                    if(timeStr < 8){
                        newTime = `${timeArr[0]-1}-12-${monDay+Number(timeStr)-7}`
                        monD = monDay+Number(timeStr)-7
                    }else{
                        newTime = `${timeArr[0]}-${timeArr[1]}-${Number(timeStr)-7}`
                        monD = Number(timeStr)-7
                    }
                }else{
                    if(timeStr < 8){
                        newTime = `${timeArr[0]}-${timeArr[1]-1}-${monDay+Number(timeStr)-7}`
                        monD = monDay+Number(timeStr)-7
                    }else{
                        newTime = `${timeArr[0]}-${timeArr[1]}-${Number(timeStr)-7}`
                        monD = Number(timeStr)-7
                    }
                }
                
                this.btnDisCopy = false

            }else{//下周
                let y = timeArr[0]//年
                let mon = timeArr[1]//月
                let monDay //每个月有多少天
                let Leap = ''+y/4
                if(Leap.length>3){
                    if(mon==2){
                        monDay=28
                    }else if(mon==4 || mon==6 || mon==9 || mon==11){
                        monDay=30
                    }else{
                        monDay=31
                    }
                }else{//闰年
                    if(mon==2){
                        monDay=29
                    }else if(mon==4 || mon==6 || mon==9 || mon==11){
                        monDay=30
                    }else{
                        monDay=31
                    }
                }
                if (Number(timeArr[1])+1>12){
                    if(timeStr>24){
                        newTime = `${Number(timeArr[0])+1}-01-${Number(timeStr)+7-monDay}`
                        monD = Number(timeStr)+7-monDay
                    }else{//${Number(timeArr[1])+1}
                        newTime = `${timeArr[0]}-12-${Number(timeStr)+7}`
                        monD = Number(timeStr)+7
                    }
                }else{
                    if( timeStr>monDay-7 ){
                        newTime = `${timeArr[0]}-${Number(timeArr[1])+1}-${Number(timeStr)+7-monDay}`
                        monD = Number(timeStr)+7-monDay
                    }else{
                        newTime = `${timeArr[0]}-${Number(timeArr[1])}-${Number(timeStr)+7}`
                        monD = Number(timeStr)+7
                    }
                }
                // 未到时间 禁用
                var modelArr = time.split(' ')
                const endTimeStamp = new Date(this.resDate).getTime()
                // //获取周一时间戳
                if(modelArr[1]){
                    let huoqu = new Date(modelArr[1]).getTime()+86400000*7
                    let nowDate =formatDate( new Date(huoqu), 'yyyy-M-d')
                    let timeArray = nowDate.split('-')
                    let timeyear = timeArray[0]
                    let timemonth = timeArray[1]
                    let timeday = timeArray[2]
                    if(timemonth<10){
                        timemonth = '0' + timemonth
                    }
                    if(timeday<10){
                        timeday = '0' + timeday
                    }
                    nowDate= timeyear+'-' +timemonth+'-'+timeday
                    if (huoqu >= endTimeStamp) {
                        this.btnDisCopy = true
                    }
                }else{
                    let huoqu = new Date(modelArr[0]).getTime()+86400000*7
                    let nowDate =formatDate( new Date(huoqu), 'yyyy-M-d')
                    let timeArray = nowDate.split('-')
                    let timeyear = timeArray[0]
                    let timemonth = timeArray[1]
                    let timeday = timeArray[2]
                    if(timemonth<10){
                        timemonth = '0' + timemonth
                    }
                    if(timeday<10){
                        timeday = '0' + timeday
                    }
                    nowDate= timeyear+'-' +timemonth+'-'+timeday
                    if (huoqu >= endTimeStamp) {
                        this.btnDisCopy = true
                    }
                }
                // let huoqu = new Date(modelArr[1]).getTime()+86400000*7
                // let nowDate =formatDate( new Date(huoqu), 'yyyy-M-d')

            }
            // 获取时间区间
            let ddd = monD//本周的周一
            let sundaySjc = new Date(newTime).setDate(ddd)//获取周一时间戳
            let saturdaySjc = new Date(newTime).setDate(ddd)+86400000*6//获取周日时间戳
            this.getTimeSection(sundaySjc,saturdaySjc)
            this.weekvalue = newTime
            this.FaultAlarmtTable()
        },
        // 获取时间区间
        getTimeSection(sundaySjc,saturdaySjc){
            // 获取start周日
            let sundayStr = new Date(parseInt(sundaySjc)).toLocaleString()//时间戳转成日期格式字符串
            let arr = sundayStr.split(' ')//去掉时分秒
            let start = arr[0].split('/')//获取年月日
            let startArr = start.map(item=>{//补0
                if(Number(item)<10){
                    item = '0'+ item
                }
                return item
            })
            // 获取end周六
            let saturdayStr = new Date(parseInt(saturdaySjc)).toLocaleString()//时间戳转成日期格式字符串
            let arr2 = saturdayStr.split(' ')//去掉时分秒
            let end = arr2[0].split('/')//获取年月日
            let endArr = end.map(item=>{//补0
                if(Number(item)<10){
                item = '0'+ item
                }
                return item
            })
            this.startDate = startArr
            this.endDate = endArr
        },
        //或许现在的日期
        GetMonday() {
            var dd = new Date()
            var myDate = new Date();
            var week = dd.getDay() //获取时间的星期数
            var minus = week ? week - 1 : 6
            dd.setDate(dd.getDate() - minus) //获取minus天前的日期
            var y = dd.getFullYear()
            var m = dd.getMonth() + 1 //获取月份
            var d = dd.getDate()
            this.weekvalue=y + "-" + m + "-" + d
            // 获取时间区间
            var tDate = myDate.getDate()
            var tDay = myDate.getDay()
            let ddd = tDate-(tDay-1)//本周的周一
            let sundaySjc = new Date().setDate(ddd)//获取周日时间戳
            let saturdaySjc = new Date().setDate(ddd)+86400000*6//获取周日时间戳
            this.getTimeSection(sundaySjc,saturdaySjc)
        },
        //表格数据
        FaultAlarmtTable(){
            let _this = this
            this.tableloading = true
            this.axios({
                method: 'post',
                url: '/url/getAlarmStatisticsReport',
                params:{
                    language: _this.$store.state.lang,
                    shopId: _this.shopId,
                    date: _this.weekvalue,
                    dataType:1
                }
            }).then(function(res){
                if (res.data.success === 'true') {
                    _this.noMachineInFactory=false
                    _this.policeTabletitle = res.data.tableTitle
                    res.data.leftTitle.forEach(item=>{//将0变成''
                        for(let key in item.alarmReportList){
                            if(item.alarmReportList[key] === 0){
                            item.alarmReportList[key] = ''
                            }
                        }
                    })
                    _this.policeTableData = res.data.leftTitle
                    if(_this.policeTableData){
                        _this.heightTable = '600'
                    }
                    // 合计（行）
                    _this.secondTable = res.data.totalDate.alarmReportList
                    _this.titleStartDate=res.data.startTime
                    _this.titleEndDate=res.data.endTime
                    _this.machineNums=res.data.machineIds
                }else{
                    _this.noMachineInFactory=true
                }
            }).then(function(){
                if(_this.noMachineInFactory==false){
                    // setTimeout(() => {
                        _this.$nextTick(() => {
                            _this.$refs.policeTable.doLayout()
                        })
                    // }, 300)
                }
                _this.tableloading = false
            })
        },
    }
}
</script>
<style scoped>
    .WorkShopAlarmStatistics{
        min-width: 1365px!important;
    }
    .mainWrao{
        height: 100%;
        min-width: 100%;
        background-color: #f6f9fc;
        box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
        box-sizing: border-box;
        border-radius: 4px;
        padding-bottom: 30px;
        position: relative;
    }
    /* 头部车间名-工厂名  */
    .mainWrao .title{
        overflow: hidden;
        padding: 20px 25px;
        background-color: rgba(255, 255, 255, 0.7);
        border-bottom: 1px solid #e8e8e8;
        display:flex;
        align-items: center;
        justify-content: space-between;
    }
    .mainWrao .title .titlename{
        display:flex;
        flex-wrap: wrap;
        font-size: 24px;
        color: #525f7f;
        line-height: 40px;
        width: calc(100% - 530px);
    }
    .mainWrao .title p span{
        margin-right: 15px;
    }
    .mainWrao .rightWrap{
        float: right;
        display:flex;
        align-items: center;
    }
    .rightWrap .everyWorkShop{
        border: 1px solid #409EFF;
        border-radius: 10px;
        padding: 8px 10px;
        color:#409EFF;
        margin-right:10px;
        cursor: pointer;
    }
    .rightWrap .activeWorkShop{
        background:#409EFF;
        color:#fff;
    }
    /* 车间故障统计报告 */
    .mainWrao .tableWrap{
        box-sizing: border-box;
        margin: 20px 15px;
    }
    .mainWrao .tableWrap .dlwarp{
        margin-top: 40px;
        display:flex;
        justify-content: space-between;
        align-items: center;
    }
    .mainWrao .tableWrap .miniTitle{
        font-weight: bold;
        font-size: 16px;
        display: inline-block;
    }
    .ProductivityReport .weekPicker{
        width: 152px;
        margin: 0 10px;
    }
    /* 导出按钮 */
    .datepart .exportBtn{
        width: 100px;
        padding: 8px 10px;
        font-size: 13px;
    }
    .changetime, .ProductivityReport .miniTitle{
        display: inline-block;
    }
    .noMachineTitle{
        color:#909399;
        line-height: 100px;
        text-align: center;
    }
</style>